// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Cards de contagem ── */
.hearing-counts {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.hearing-count-card {
  flex: 1 1;
  min-width: 140px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #fff;
}

.hearing-count-card--hoje {
  border-color: #b6d4fe;
  background: #f0f6ff;
}

.hearing-count-card--agendadas {
  border-color: #b7e4c7;
  background: #f0faf4;
}

.hearing-count-card--realizadas {
  border-color: #ffe69c;
  background: #fffdf0;
}

.hearing-count-label {
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.hearing-count-value {
  font-size: 28px;
  font-weight: 700;
  color: #212529;
  line-height: 1;
}

.hearing-count-card--hoje .hearing-count-value { color: #0056b3; }
.hearing-count-card--agendadas .hearing-count-value { color: #198754; }
.hearing-count-card--realizadas .hearing-count-value { color: #856404; }

/* ── Seção audiências do dia ── */
.hearing-today-section {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  background: #fff;
}

.hearing-today-title {
  font-size: 14px;
  font-weight: 600;
  color: #212529;
  margin: 0 0 12px;
}

.hearing-today-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 260px;
  overflow-y: auto;
  padding-right: 4px;
}

.hearing-today-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  background: #f8f9fa;
  flex-wrap: wrap;
}

.hearing-today-time {
  font-size: 13px;
  font-weight: 700;
  color: #0056b3;
  min-width: 48px;
}

.hearing-today-name {
  font-size: 13px;
  font-weight: 600;
  color: #212529;
  flex: 1 1;
  min-width: 120px;
}

.hearing-today-unit {
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  background: #6c757d;
  border-radius: 4px;
  padding: 2px 6px;
  white-space: nowrap;
}

.hearing-today-type {
  font-size: 12px;
  color: #6c757d;
}

.hearing-today-court {
  font-size: 12px;
  color: #495057;
}

/* ── Toolbar (filtros + botão) ── */
.hearing-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.hearing-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  flex: 1 1;
}

.hearing-filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  min-width: 140px;
}

.hearing-filter-group label {
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
}

.hearing-filter-group input,
.hearing-filter-group select {
  padding: 8px 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 13px;
  background: #fff;
  color: #212529;
  height: 36px;
}

.hearing-btn-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #0d6efd;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  height: 36px;
  transition: background 0.15s;
}

.hearing-btn-add:hover {
  background: #0b5ed7;
}

/* ── Lista de audiências ── */
.hearing-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.hearing-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.hearing-card-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.hearing-card-name {
  font-size: 15px;
  font-weight: 600;
  color: #212529;
  flex: 1 1;
}

.hearing-card-unit {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
}

/* ── Badge de modalidade ── */
.hearing-modality-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  margin-top: 2px;
}

.hearing-modality-badge--virtual {
  background: #e0d7ff;
  color: #4c1d95;
}

.hearing-modality-badge--presencial {
  background: #d1fae5;
  color: #064e3b;
}

/* ── Botão visualizar ── */
.hearing-btn-view,
.hearing-btn-edit {
  background: none;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  color: #6c757d;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  flex-shrink: 0;
  transition: border-color 0.15s, color 0.15s;
}

.hearing-btn-view:hover,
.hearing-btn-edit:hover {
  border-color: #0d6efd;
  color: #0d6efd;
}

.hearing-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 6px 20px;
}

.hearing-card-field {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.hearing-card-field-label {
  font-size: 10px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.hearing-card-field-value {
  font-size: 13px;
  color: #212529;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hearing-card-field-value a {
  color: #0056b3;
  text-decoration: none;
}

.hearing-card-field-value a:hover {
  text-decoration: underline;
}

/* ── Badges de status ── */
.hearing-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.hearing-badge--scheduled {
  background: #cfe2ff;
  color: #084298;
}

.hearing-badge--done {
  background: #d1e7dd;
  color: #0a3622;
}

.hearing-badge--notdone {
  background: #f8d7da;
  color: #58151c;
}

.hearing-badge--progress {
  background: #ffe5d0;
  color: #7c3a04;
}

/* ── Paginação ── */
.hearing-pagination-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  gap: 10px;
}

.hearing-page-size {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #6c757d;
}

.hearing-page-size select {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 3px 8px;
  font-size: 13px;
  color: #212529;
  background: #fff;
  cursor: pointer;
}

/* ── Empty state ── */
.hearing-empty {
  text-align: center;
  color: #6c757d;
  padding: 32px 0;
  font-size: 14px;
}

/* ── Formulário no modal ── */
.hearing-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 4px 0;
}

.hearing-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.hearing-form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.hearing-form-group label {
  font-size: 13px;
  font-weight: 500;
  color: #495057;
}

.hearing-form-group input,
.hearing-form-group select,
.hearing-form-group textarea {
  padding: 8px 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 13px;
  color: #212529;
  background: #fff;
}

.hearing-form-group textarea {
  resize: vertical;
  min-height: 70px;
}

.hearing-form-check {
  flex-direction: row;
  align-items: center;
}

.hearing-form-check label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.hearing-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 4px;
}

.hearing-btn-cancel {
  padding: 8px 18px;
  background: #fff;
  color: #6c757d;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}

.hearing-btn-cancel:hover {
  background: #f8f9fa;
}

.hearing-btn-submit {
  padding: 8px 20px;
  background: #0d6efd;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.hearing-btn-submit:hover {
  background: #0b5ed7;
}

.hearing-btn-submit:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* ── Interno selecionado ── */
.hearing-selected-internal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid #b6d4fe;
  border-radius: 6px;
  background: #f0f6ff;
  font-size: 13px;
  font-weight: 500;
  color: #0056b3;
}

.hearing-internal-unit {
  display: block;
  font-size: 11px;
  color: #6c757d;
  margin-top: 4px;
}

.hearing-btn-clear {
  background: none;
  border: none;
  color: #6c757d;
  font-size: 15px;
  cursor: pointer;
  line-height: 1;
  padding: 0 2px;
}

.hearing-btn-clear:hover {
  color: #212529;
}

/* ── Autocomplete comarca/vara ── */
.hearing-form-field {
  position: relative;
}

.hearing-suggestions {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 200;
  list-style: none;
  margin: 0;
  padding: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.hearing-suggestions li {
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
  color: #212529;
  border-bottom: 1px solid #f0f0f0;
}

.hearing-suggestions li:last-child {
  border-bottom: none;
}

.hearing-suggestions li:hover {
  background: #f0f6ff;
}

.hearing-search-loading {
  display: block;
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
}

/* ── Ações do card ── */
.hearing-card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.hearing-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  text-decoration: none;
  transition: opacity 0.15s;
}

.hearing-action-btn:hover { opacity: 0.82; }

.hearing-action-btn--start {
  background: #fff3cd;
  color: #664d03;
  border-color: #ffc107;
}

.hearing-action-btn--conclude {
  background: #d1e7dd;
  color: #0a3622;
  border-color: #198754;
}

.hearing-action-btn--upload {
  background: #e2e8f0;
  color: #374151;
  border-color: #cbd5e1;
}

.hearing-action-btn--download {
  background: #cfe2ff;
  color: #084298;
  border-color: #b6d4fe;
}

/* ── Modal de conclusão ── */
.hearing-status-modal-name {
  font-size: 14px;
  font-weight: 600;
  color: #212529;
  margin: 0 0 12px;
}

.hearing-status-options {
  display: flex;
  gap: 12px;
}

.hearing-status-option {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  transition: border-color 0.15s, background 0.15s;
}

.hearing-status-option input[type="radio"] { accent-color: #198754; }

.hearing-status-option--selected {
  border-color: #198754;
  background: #d1e7dd;
  color: #0a3622;
}

.hearing-status-option--notdone { accent-color: #dc3545; }

.hearing-status-option--selected.hearing-status-option--notdone {
  border-color: #dc3545;
  background: #f8d7da;
  color: #58151c;
}

/* ── Modal de visualização ── */
.hearing-view-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 0;
}

.hearing-view-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.hearing-view-name {
  font-size: 15px;
  font-weight: 700;
  color: #212529;
  margin: 0 0 4px;
}

.hearing-view-unit {
  font-size: 12px;
  color: #6c757d;
  margin: 0;
}

.hearing-view-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px 20px;
}

.hearing-view-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.hearing-view-field--full {
  grid-column: 1 / -1;
}

/* ── Erros de campo ── */
.hearing-field-error {
  font-size: 12px;
  color: #dc3545;
  margin-top: 3px;
}

.hearing-form-group input.input-error,
.hearing-form-group select.input-error {
  border-color: #dc3545;
  background-color: #fff8f8;
}

@media (max-width: 600px) {
  .hearing-form-row {
    grid-template-columns: 1fr;
  }

  .hearing-counts {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Audiencias/audiencias.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,iDAAiD,cAAc,EAAE;AACjE,sDAAsD,cAAc,EAAE;AACtE,uDAAuD,cAAc,EAAE;;AAEvE,kCAAkC;AAClC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,4BAA4B,aAAa,EAAE;;AAE3C;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gDAAgD;AAClD;;AAEA,6CAA6C,qBAAqB,EAAE;;AAEpE;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kCAAkC,qBAAqB,EAAE;;AAEzD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* ── Cards de contagem ── */\n.hearing-counts {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.hearing-count-card {\n  flex: 1;\n  min-width: 140px;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  background: #fff;\n}\n\n.hearing-count-card--hoje {\n  border-color: #b6d4fe;\n  background: #f0f6ff;\n}\n\n.hearing-count-card--agendadas {\n  border-color: #b7e4c7;\n  background: #f0faf4;\n}\n\n.hearing-count-card--realizadas {\n  border-color: #ffe69c;\n  background: #fffdf0;\n}\n\n.hearing-count-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.hearing-count-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #212529;\n  line-height: 1;\n}\n\n.hearing-count-card--hoje .hearing-count-value { color: #0056b3; }\n.hearing-count-card--agendadas .hearing-count-value { color: #198754; }\n.hearing-count-card--realizadas .hearing-count-value { color: #856404; }\n\n/* ── Seção audiências do dia ── */\n.hearing-today-section {\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 24px;\n  background: #fff;\n}\n\n.hearing-today-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #212529;\n  margin: 0 0 12px;\n}\n\n.hearing-today-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 260px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.hearing-today-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n  background: #f8f9fa;\n  flex-wrap: wrap;\n}\n\n.hearing-today-time {\n  font-size: 13px;\n  font-weight: 700;\n  color: #0056b3;\n  min-width: 48px;\n}\n\n.hearing-today-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #212529;\n  flex: 1;\n  min-width: 120px;\n}\n\n.hearing-today-unit {\n  font-size: 11px;\n  font-weight: 600;\n  color: #fff;\n  background: #6c757d;\n  border-radius: 4px;\n  padding: 2px 6px;\n  white-space: nowrap;\n}\n\n.hearing-today-type {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.hearing-today-court {\n  font-size: 12px;\n  color: #495057;\n}\n\n/* ── Toolbar (filtros + botão) ── */\n.hearing-toolbar {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.hearing-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  flex: 1;\n}\n\n.hearing-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 140px;\n}\n\n.hearing-filter-group label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6c757d;\n}\n\n.hearing-filter-group input,\n.hearing-filter-group select {\n  padding: 8px 10px;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  font-size: 13px;\n  background: #fff;\n  color: #212529;\n  height: 36px;\n}\n\n.hearing-btn-add {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: #0d6efd;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  height: 36px;\n  transition: background 0.15s;\n}\n\n.hearing-btn-add:hover {\n  background: #0b5ed7;\n}\n\n/* ── Lista de audiências ── */\n.hearing-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.hearing-card {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 10px 14px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.hearing-card-header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 8px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.hearing-card-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: #212529;\n  flex: 1;\n}\n\n.hearing-card-unit {\n  font-size: 12px;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n/* ── Badge de modalidade ── */\n.hearing-modality-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 2px;\n}\n\n.hearing-modality-badge--virtual {\n  background: #e0d7ff;\n  color: #4c1d95;\n}\n\n.hearing-modality-badge--presencial {\n  background: #d1fae5;\n  color: #064e3b;\n}\n\n/* ── Botão visualizar ── */\n.hearing-btn-view,\n.hearing-btn-edit {\n  background: none;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  color: #6c757d;\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 12px;\n  flex-shrink: 0;\n  transition: border-color 0.15s, color 0.15s;\n}\n\n.hearing-btn-view:hover,\n.hearing-btn-edit:hover {\n  border-color: #0d6efd;\n  color: #0d6efd;\n}\n\n.hearing-card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 6px 20px;\n}\n\n.hearing-card-field {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.hearing-card-field-label {\n  font-size: 10px;\n  font-weight: 600;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.hearing-card-field-value {\n  font-size: 13px;\n  color: #212529;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hearing-card-field-value a {\n  color: #0056b3;\n  text-decoration: none;\n}\n\n.hearing-card-field-value a:hover {\n  text-decoration: underline;\n}\n\n/* ── Badges de status ── */\n.hearing-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.hearing-badge--scheduled {\n  background: #cfe2ff;\n  color: #084298;\n}\n\n.hearing-badge--done {\n  background: #d1e7dd;\n  color: #0a3622;\n}\n\n.hearing-badge--notdone {\n  background: #f8d7da;\n  color: #58151c;\n}\n\n.hearing-badge--progress {\n  background: #ffe5d0;\n  color: #7c3a04;\n}\n\n/* ── Paginação ── */\n.hearing-pagination-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n  gap: 10px;\n}\n\n.hearing-page-size {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #6c757d;\n}\n\n.hearing-page-size select {\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 3px 8px;\n  font-size: 13px;\n  color: #212529;\n  background: #fff;\n  cursor: pointer;\n}\n\n/* ── Empty state ── */\n.hearing-empty {\n  text-align: center;\n  color: #6c757d;\n  padding: 32px 0;\n  font-size: 14px;\n}\n\n/* ── Formulário no modal ── */\n.hearing-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 4px 0;\n}\n\n.hearing-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.hearing-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.hearing-form-group label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.hearing-form-group input,\n.hearing-form-group select,\n.hearing-form-group textarea {\n  padding: 8px 10px;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #212529;\n  background: #fff;\n}\n\n.hearing-form-group textarea {\n  resize: vertical;\n  min-height: 70px;\n}\n\n.hearing-form-check {\n  flex-direction: row;\n  align-items: center;\n}\n\n.hearing-form-check label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.hearing-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: 4px;\n}\n\n.hearing-btn-cancel {\n  padding: 8px 18px;\n  background: #fff;\n  color: #6c757d;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.hearing-btn-cancel:hover {\n  background: #f8f9fa;\n}\n\n.hearing-btn-submit {\n  padding: 8px 20px;\n  background: #0d6efd;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.hearing-btn-submit:hover {\n  background: #0b5ed7;\n}\n\n.hearing-btn-submit:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n/* ── Interno selecionado ── */\n.hearing-selected-internal {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border: 1px solid #b6d4fe;\n  border-radius: 6px;\n  background: #f0f6ff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0056b3;\n}\n\n.hearing-internal-unit {\n  display: block;\n  font-size: 11px;\n  color: #6c757d;\n  margin-top: 4px;\n}\n\n.hearing-btn-clear {\n  background: none;\n  border: none;\n  color: #6c757d;\n  font-size: 15px;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0 2px;\n}\n\n.hearing-btn-clear:hover {\n  color: #212529;\n}\n\n/* ── Autocomplete comarca/vara ── */\n.hearing-form-field {\n  position: relative;\n}\n\n.hearing-suggestions {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 200;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.hearing-suggestions li {\n  padding: 8px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  color: #212529;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.hearing-suggestions li:last-child {\n  border-bottom: none;\n}\n\n.hearing-suggestions li:hover {\n  background: #f0f6ff;\n}\n\n.hearing-search-loading {\n  display: block;\n  font-size: 12px;\n  color: #6c757d;\n  margin-top: 4px;\n}\n\n/* ── Ações do card ── */\n.hearing-card-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.hearing-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 14px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n  text-decoration: none;\n  transition: opacity 0.15s;\n}\n\n.hearing-action-btn:hover { opacity: 0.82; }\n\n.hearing-action-btn--start {\n  background: #fff3cd;\n  color: #664d03;\n  border-color: #ffc107;\n}\n\n.hearing-action-btn--conclude {\n  background: #d1e7dd;\n  color: #0a3622;\n  border-color: #198754;\n}\n\n.hearing-action-btn--upload {\n  background: #e2e8f0;\n  color: #374151;\n  border-color: #cbd5e1;\n}\n\n.hearing-action-btn--download {\n  background: #cfe2ff;\n  color: #084298;\n  border-color: #b6d4fe;\n}\n\n/* ── Modal de conclusão ── */\n.hearing-status-modal-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #212529;\n  margin: 0 0 12px;\n}\n\n.hearing-status-options {\n  display: flex;\n  gap: 12px;\n}\n\n.hearing-status-option {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.hearing-status-option input[type=\"radio\"] { accent-color: #198754; }\n\n.hearing-status-option--selected {\n  border-color: #198754;\n  background: #d1e7dd;\n  color: #0a3622;\n}\n\n.hearing-status-option--notdone { accent-color: #dc3545; }\n\n.hearing-status-option--selected.hearing-status-option--notdone {\n  border-color: #dc3545;\n  background: #f8d7da;\n  color: #58151c;\n}\n\n/* ── Modal de visualização ── */\n.hearing-view-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 4px 0;\n}\n\n.hearing-view-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.hearing-view-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #212529;\n  margin: 0 0 4px;\n}\n\n.hearing-view-unit {\n  font-size: 12px;\n  color: #6c757d;\n  margin: 0;\n}\n\n.hearing-view-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 12px 20px;\n}\n\n.hearing-view-field {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.hearing-view-field--full {\n  grid-column: 1 / -1;\n}\n\n/* ── Erros de campo ── */\n.hearing-field-error {\n  font-size: 12px;\n  color: #dc3545;\n  margin-top: 3px;\n}\n\n.hearing-form-group input.input-error,\n.hearing-form-group select.input-error {\n  border-color: #dc3545;\n  background-color: #fff8f8;\n}\n\n@media (max-width: 600px) {\n  .hearing-form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .hearing-counts {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
